
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "1024",
    "height": "1024",
    "viewBox": "0 0 1024 1024"
  },
  "children": [
    {
      "tag": "title"
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "icomoon-ignore"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M1024 854v6q0 44-22 82t-60 60-82 22h-696q-45 0-82.5-22t-59.5-60-22-82v-696q0-44 22-82t59.5-60 82.5-22h695q45 0 82.5 22t60 59.5 22.5 82.5v690M780 399q-29-30-63-55l-10-7q24-12 38-32t14-44.5-15-45.5-40-32.5-55-11.5q-19 0-37 6-7 2-13 6-1 1-4 0t-4-2q-7-11-21-23v0q-25-22-58-21.5t-58 21.5v0q-14 12-21 23-1 1-4 1.5t-4 0.5q-6-4-13-6-17-6-37-6-30 0-55 11.5t-40 32.5-15 45.5 14 44.5 38 32q-3 2-8 6l-2 1q-31 22-63 55-95 97-95 205 0 101 50 168 45 60 129 89 76 27 180 27h8q104 0 180-27 84-29 129-89 50-67 50-168 0-108-95-205M616 593h-75v29h55q12 0 20.5 8.5t8.5 20.5-8.5 20.5-20.5 8.5h-55v44q0 12-8.5 20.5t-20.5 8.5-20.5-8.5-8.5-20.5v-44h-58q-12 0-20.5-8.5t-8.5-20.5 8.5-20.5 20.5-8.5h58v-29h-75q-12 0-20.5-8.5t-8.5-20.5 8.5-20 20.5-8h34l-25-54q-9-9-9-21t8.5-20.5 20.5-8.5 21 9l54 83 58-83q9-9 21-9t20.5 8.5 8.5 20.5-9 21l-30 54h35q12 0 20 8t8.5 20-8 20.5-20.5 8.5z"
      }
    }
  ]
})
    }
  